import {RigServiceData} from "../types/RigServiceData";
import {StagingTitelineAppRigService} from "../types/StagingTitelineAppRigService";
import { getApiUrl } from '../config/api';

export const fetchRigServiceByPid = async (pid?: number, aid: number = -1): Promise<RigServiceData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineRigService/GetRigServiceByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No rig service found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching rig service for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppRigService[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((service) => service.DataSource === aid.toString());
        }

        return backendData.map((service) => ({
            key: service.RsId,
            rs_id: service.RsId,
            pid: service.Pid,
            service_type: service.ServiceType,
            daily: service.Daily,
            weekly: service.Weekly,
            thousand_hour: service.ThousandHour,
        }));

    } catch (error) {
        console.error("Error in fetchRigServiceByPid API call:", error);
        return [];
    }
};

export const addRigServiceRow = async (rigServiceRow: RigServiceData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineRigService/AddRigService');

    const cloudPayload = [
        {
            Pid: rigServiceRow.pid,
            ServiceType: rigServiceRow.service_type,
            Daily: rigServiceRow.daily,
            Weekly: rigServiceRow.weekly,
            ThousandHour: rigServiceRow.thousand_hour,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Rig Service row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add Rig Service row to cloud:",
                response.status, response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addRigServiceRow API call:", error);
        return false;
    }
};

export const updateRigServiceRow = async (rs_id: number, updatedRow: RigServiceData) => {
    const apiUrl = getApiUrl(`/api/TitelineRigService/UpdateRigServiceByRsId/${rs_id}`);

    const cloudPayload = {
        ServiceType: updatedRow.service_type,
        Daily: updatedRow.daily,
        Weekly: updatedRow.weekly,
        ThousandHour: updatedRow.thousand_hour,
    };

    console.log("cloudPayload:", cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Rig Service row with RsId ${rs_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update Rig Service row with RsId ${rs_id}:`,
                response.status, response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateRigServiceRow API call:", error);
        return false;
    }
};

export const deleteRigServiceByRsId = async (rs_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineRigService/DeleteRigServiceByRsId/${rs_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteRigServiceByRsId API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete Rig Service row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteRigServiceByRsId API call:", error);
        return false;
    }
};